"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.More = void 0;
const react_1 = __importDefault(require("react"));
exports.More = (props) => {
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", viewBox: "0 0 7 2" }, props),
        react_1.default.createElement("circle", { cx: "0.921", cy: "0.921", r: "0.921", fill: "#fff" }),
        react_1.default.createElement("circle", { cx: "6.079", cy: "0.921", r: "0.921", fill: "#fff" }),
        react_1.default.createElement("circle", { cx: "3.5", cy: "0.921", r: "0.921", fill: "#fff" })));
};
